import { render } from "./ProjectCreationView.vue?vue&type=template&id=03d699db&ts=true"
import script from "./ProjectCreationView.vue?vue&type=script&lang=ts"
export * from "./ProjectCreationView.vue?vue&type=script&lang=ts"

import "./ProjectCreationView.vue?vue&type=style&index=0&id=03d699db&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__